import _Vue from "vue";
import Buefy from "buefy";

// This is your plugin object. It can be exported to be used anywhere.
export default {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install: (Vue: typeof _Vue, options?: any): void => {
    Vue.use(Buefy, {
      // set fontawsome as default icon
      defaultIconComponent: "vue-fontawesome",
      defaultIconPack: "fa",
    });

    console.log("Buefy initialised");
  },
};
